<script>
    
    import { db } from './firebase.config.js';
    import OneHBCU from './OneHBCU.svelte';

    // Form Text
    let text = 'some task';
    let hbcus=[]

    // Query requires an index, see screenshot below
    try {
        db.collection('hbcu').orderBy("School").onSnapshot(data => {
        hbcus = data.docs
    })

    }
    catch (err) {
        console.log(err.message)
    }

</script>



<!--<table class="table table-striped table-condensed">
    <tr>
    <th>Founded</th><th>School</th>
    </tr> -->

	{#each hbcus as hbcu}
        <!--{JSON.stringify( hbcu.data())}-->

        <OneHBCU id={hbcu.id} hbcu={hbcu.data()}/>
        
	{/each}
<!--</table>-->
